module.exports = __webpack_public_path__ + "img/yue.3ea2085e.jpeg";